import { Injectable } from '@angular/core';
// import { environment } from 'apps/ciptech/src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class WsComentarioService {
  private endpoint = `/api/WsComentarios`;

  constructor(private http: HttpClient) { }

  insert(comentario: any, ctx?: string): Observable<number> {
    return this.http.post<number>(`${this.endpoint}`, comentario, { headers: { context: ctx || '' } });
  }

}
